import * as React from 'react';
import {useState} from 'react';
import {IsNotEmpty} from "class-validator";
import {container} from "@intelingu/core/IoC/container";
import {WorkspaceStore} from "../../../../stores/WorkspaceStore";
import {useGetVocabularyCardByIdQuery, useUpdateCardMutation} from "../../../../types.d";
import {getParam} from "../../../../utils/getParam";
import {Redirect} from "react-router";
import moment from "moment";
import {Form} from "@intelingu/core/components/form/Form";
import {FormGroup} from "../../../partials/form/elements/FormGroup";
import {Field} from "@intelingu/core/components/form/Field";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import {TinyMCE} from "../../../partials/form/elements/TinyMCE";

export class Validator {

    @IsNotEmpty()
    info;

}

export const CreateMediaForm = props => {
    const [created, setCreated] = useState<boolean>(false);

    const courseId = container.get(WorkspaceStore).courseId;

    const [ updateCard, { data: updatedCard } ] = useUpdateCardMutation({
        fetchPolicy: 'no-cache'
    });

    const {
        data
    } = useGetVocabularyCardByIdQuery({
        variables: { id: getParam<number>('card_id') }
    });

    if (!data || !data.card) {
        return <h2>Loading...</h2>
    }

    const { card } = data;

    if (created) {
        return <Redirect to={`/creation/next/${courseId}/ME`} />
    }

    const date: string = moment().format("YYYY-MM-DD HH:mm:ss");
    const wordTranslation = card.wordTranslation;

    return <Form
        validator={Validator}
        onSubmit={async (data, done) => {
            let value = JSON.parse(JSON.stringify(data));

            value = value = {
                ...value,
                ...{
                    infoFilledAt: date
                }
            };

            await updateCard({
                variables: {
                    id: getParam<number>('card_id'),
                    input: value
                }
            });

            done();

            setCreated(true);
        }}
    >
        <div className="row px-3">
            <div className="col-4">
                <label><strong>Source Language</strong>:</label>
                <span className="mx-1">{ wordTranslation.sourceLanguage.name }</span>
            </div>
            <div className="col-8">
                <label>
                    <strong>Translation Language</strong>:</label>
                <span className="mx-1">{ wordTranslation.translationLanguage.name }</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-12">
                <label><strong>Part Of Speech</strong>:</label>
                <span className="mx-1">{ wordTranslation.sourceWord.posDefinition } ({ wordTranslation.sourceWord.pos })</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-4">
                <label><strong>Vocabulary</strong>:</label>
                <span className="mx-1">{ wordTranslation.sourceWord.lemma }</span>
            </div>
            <div className="col-8">
                <label><strong>Translation</strong>:</label>
                <span className="mx-1">{ wordTranslation.translationWord.lemma }</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-12">
                <label><strong>Translation Audio</strong>:</label>
                <span className="mx-1">
                    <audio controls={true} src={wordTranslation.audio} />
                </span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-12">
                <label><strong>Comment to Media Editor</strong>:</label>
                <span className="mx-1">{ card.editingRequiredComment }</span>
            </div>
        </div>

        <FormGroup
            className={'mt-5'}
            label={'Info'}
            required={true}
        >
            <Field
                name={'info'}
                render={props => (
                    <TinyMCE
                        toolbar={'undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help'}
                        {...props} />
                )} />
        </FormGroup>

        <div className={'col-12'}>
            <Field submit render={props => <SubmitButton {...props}>Done</SubmitButton>} />
        </div>
    </Form>
};

export const CreateMedia = props => (
    <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <div className="ig-form-heading">
                <h1 className="form-primary-title">DESIGN GREAT MEDIA CONTENT</h1>
            </div>

            <CreateMediaForm />
        </div>
    </div>
);
